import React from "react";
import { Component } from "react";
import { checkTranslation, chooseFontColor, translate } from "../../utils/useful";
import FixedView from "../FixedView";
import TextComponentFloatConfig from "./TextComponentFloatConfig";
import MainComponentFloatConfig from "./MainComponentFloatConfig";
import VideoComponentFloatConfig from "./VideoComponentFloatConfig";
import OtherComponentFloatConfig from "./OtherComponentFloatConfig";

class ComponentFloatConfig extends Component {
  state = {

  };



  render() {

    return (


      <div style={{ zIndex: 3 }}>
        {/* {this.props.widgetType == 'ImageWidget' ? ( */}
        <MainComponentFloatConfig header={this.props.header} width={this.props.width} fields={this.props.fields} params={this.props.params} element={this.props.element} setElementSettings={this.props.setElementSettings} provided={this.props.provided} setData={this.props.setData} styleInfo={this.props.styleInfo} makeInvisible={this.props.makeInvisible} index={this.props.index} editorId={this.props.header.id} startMove={this.props.startMove} doRemoveElement={this.props.doRemoveElement} duplicateElement={this.props.duplicateElement} setRowColSettings={this.props.setRowColSettings} section={this.props.section} changeSelectedTextEffects={this.props.changeSelectedTextEffects} showConfig={this.props.showConfig} insertText={this.props.insertText} />

        {/* ) : this.props.widgetType == 'VideoInput' ? (

          <VideoComponentFloatConfig header={this.props.header} fields={this.props.fields} element={this.props.element} setElementSettings={this.props.setElementSettings} provided={this.props.provided} setData={this.props.setData} styleInfo={this.props.styleInfo} makeInvisible={this.props.makeInvisible} index={this.props.index} editorId={this.props.header.id} startMove={this.props.startMove} doRemoveElement={this.props.doRemoveElement} duplicateElement={this.props.duplicateElement} setRowColSettings={this.props.setRowColSettings} section={this.props.section} />

        ) : this.props.widgetType == 'TextWidget' ? (
          <TextComponentFloatConfig header={this.props.header} fields={this.props.fields} element={this.props.element} setElementSettings={this.props.setElementSettings} provided={this.props.provided} setData={this.props.setData} styleInfo={this.props.styleInfo} makeInvisible={this.props.makeInvisible} index={this.props.index} editorId={this.props.header.id} changeSelectedTextEffects={this.props.changeSelectedTextEffects} startMove={this.props.startMove} doRemoveElement={this.props.doRemoveElement} duplicateElement={this.props.duplicateElement} setRowColSettings={this.props.setRowColSettings} section={this.props.section} />
        ) : (

          <OtherComponentFloatConfig header={this.props.header} fields={this.props.fields} element={this.props.element} setElementSettings={this.props.setElementSettings} provided={this.props.provided} setData={this.props.setData} styleInfo={this.props.styleInfo} makeInvisible={this.props.makeInvisible} index={this.props.index} editorId={this.props.header.id} changeSelectedTextEffects={this.props.changeSelectedTextEffects} startMove={this.props.startMove} doRemoveElement={this.props.doRemoveElement} duplicateElement={this.props.duplicateElement} setRowColSettings={this.props.setRowColSettings} section={this.props.section} showConfig={this.props.showConfig} />
        )} */}
      </div>

    );
  }
}

export default ComponentFloatConfig;
